// Inbox: the student chat (DirectMessaging + components/Messaging) and the reviews tab (Feedback).
// The reviews tab keeps its older words in the base dictionary (feedback.*); what it gained with the
// redesign lives here under `feedback*`.
const messaging = {
  en: {
    hubSubtitle: 'Chat with students and read the reviews they leave on your courses',
    tabChats: 'Chats',
    searchPlaceholder: 'Search conversations...',
    loading: 'Loading...',
    noResults: 'No results',
    noResultsHint: 'Try a different name or word.',
    noConversationsYet: 'No conversations yet',
    noConversationsHint: 'A conversation appears here as soon as a student writes to you.',
    selectConversation: 'Select a conversation',
    selectConversationHint: 'Choose a conversation from the list to start writing.',
    unknownUser: 'Unknown user',
    unknownSender: 'Unknown',
    loadConversationsFailed: 'Could not load conversations',
    sendMessageFailed: 'Could not send the message',
    loadMessagesFailed: 'Could not load messages',
    loadEarlier: 'Load earlier messages',
    justNow: 'Just now',
    minutesShort: '{count} min',
    hoursShort: '{count} h',
    daysShort: '{count} d',
    noMessagesPreview: 'No messages yet',
    back: 'Back',
    activeNow: 'Online',
    offline: 'Offline',
    noMessagesYet: 'No messages yet',
    noMessagesHint: 'Say hello to start the conversation.',
    openProfile: 'Profile',
    today: 'Today',
    yesterday: 'Yesterday',
    composerPlaceholder: 'Write a message...',
    sendMessage: 'Send message',
    composerHint: 'Enter to send · Shift+Enter for a new line',
    reconnecting: 'Reconnecting...',
    typing: 'typing...',
    unread: '{count} unread',
    feedbackSearchPlaceholder: 'Search name or review...',
    feedbackReadMore: 'Read more',
    feedbackReadLess: 'Show less',
    feedbackSortLabel: 'Sort',
    feedbackSortNewest: 'Newest first',
    feedbackSortHighest: 'Highest rated first',
    feedbackSortLowest: 'Lowest rated first',
    feedbackFilterAria: 'Filter by rating',
    feedbackStars: '{count} stars',
    feedbackRatingsCount: '{count} rating',
    feedbackRatingsCount_plural: '{count} ratings',
    feedbackLoadFailed: 'Could not load the reviews',
    feedbackNoMatchTitle: 'No reviews found',
    feedbackNoMatchHint: 'Try a different search or rating.',
    feedbackClearFilters: 'Clear filters',
  },
  ru: {
    hubSubtitle: 'Переписка со студентами и отзывы, которые они оставляют о ваших курсах',
    tabChats: 'Чаты',
    searchPlaceholder: 'Поиск бесед...',
    loading: 'Загрузка...',
    noResults: 'Нет результатов',
    noResultsHint: 'Попробуйте другое имя или слово.',
    noConversationsYet: 'Пока нет бесед',
    noConversationsHint: 'Беседа появится здесь, как только студент вам напишет.',
    selectConversation: 'Выберите беседу',
    selectConversationHint: 'Выберите беседу в списке, чтобы начать переписку.',
    unknownUser: 'Неизвестный пользователь',
    unknownSender: 'Неизвестно',
    loadConversationsFailed: 'Не удалось загрузить беседы',
    sendMessageFailed: 'Не удалось отправить сообщение',
    loadMessagesFailed: 'Не удалось загрузить сообщения',
    loadEarlier: 'Загрузить более ранние сообщения',
    justNow: 'Только что',
    minutesShort: '{count} мин',
    hoursShort: '{count} ч',
    daysShort: '{count} дн',
    noMessagesPreview: 'Сообщений пока нет',
    back: 'Назад',
    activeNow: 'В сети',
    offline: 'Не в сети',
    noMessagesYet: 'Сообщений пока нет',
    noMessagesHint: 'Напишите первым, чтобы начать беседу.',
    openProfile: 'Профиль',
    today: 'Сегодня',
    yesterday: 'Вчера',
    composerPlaceholder: 'Напишите сообщение...',
    sendMessage: 'Отправить сообщение',
    composerHint: 'Enter — отправить · Shift+Enter — новая строка',
    reconnecting: 'Переподключение...',
    typing: 'печатает...',
    unread: '{count} непрочитанных',
    feedbackSearchPlaceholder: 'Поиск по имени или отзыву...',
    feedbackReadMore: 'Читать дальше',
    feedbackReadLess: 'Свернуть',
    feedbackSortLabel: 'Сортировка',
    feedbackSortNewest: 'Сначала новые',
    feedbackSortHighest: 'Сначала с высокой оценкой',
    feedbackSortLowest: 'Сначала с низкой оценкой',
    feedbackFilterAria: 'Фильтр по оценке',
    feedbackStars: '{count} звёзд',
    feedbackRatingsCount: '{count} оценка',
    feedbackRatingsCount_few: '{count} оценки',
    feedbackRatingsCount_plural: '{count} оценок',
    feedbackLoadFailed: 'Не удалось загрузить отзывы',
    feedbackNoMatchTitle: 'Отзывы не найдены',
    feedbackNoMatchHint: 'Попробуйте другой запрос или оценку.',
    feedbackClearFilters: 'Сбросить фильтры',
  },
  uz: {
    hubSubtitle: "O'quvchilar bilan yozishmalar va kurslaringizga qoldirilgan fikrlar",
    tabChats: 'Suhbatlar',
    searchPlaceholder: 'Suhbatlarni qidirish...',
    loading: 'Yuklanmoqda...',
    noResults: 'Natija topilmadi',
    noResultsHint: "Boshqa ism yoki so'z bilan qidirib ko'ring.",
    noConversationsYet: "Hozircha suhbatlar yo'q",
    noConversationsHint: "O'quvchi yozishi bilan suhbat shu yerda paydo bo'ladi.",
    selectConversation: 'Suhbatni tanlang',
    selectConversationHint: "Yozishni boshlash uchun ro'yxatdan suhbatni tanlang.",
    unknownUser: "Noma'lum foydalanuvchi",
    unknownSender: "Noma'lum",
    loadConversationsFailed: "Suhbatlarni yuklab bo'lmadi",
    sendMessageFailed: "Xabarni yuborib bo'lmadi",
    loadMessagesFailed: "Xabarlarni yuklab bo'lmadi",
    loadEarlier: 'Oldingi xabarlarni yuklash',
    justNow: 'Hozirgina',
    minutesShort: '{count} daq',
    hoursShort: '{count} soat',
    daysShort: '{count} kun',
    noMessagesPreview: "Hozircha xabarlar yo'q",
    back: 'Orqaga',
    activeNow: 'Onlayn',
    offline: 'Oflayn',
    noMessagesYet: "Hozircha xabarlar yo'q",
    noMessagesHint: "Birinchi bo'lib salom yozing.",
    openProfile: 'Profil',
    today: 'Bugun',
    yesterday: 'Kecha',
    composerPlaceholder: 'Xabar yozing...',
    sendMessage: 'Xabar yuborish',
    composerHint: 'Enter — yuborish · Shift+Enter — yangi qator',
    reconnecting: 'Qayta ulanmoqda...',
    typing: 'yozmoqda...',
    unread: "{count} ta o'qilmagan",
    feedbackSearchPlaceholder: "Ism yoki fikr bo'yicha qidirish...",
    feedbackReadMore: "Ko'proq o'qish",
    feedbackReadLess: 'Yopish',
    feedbackSortLabel: 'Saralash',
    feedbackSortNewest: 'Avval yangilari',
    feedbackSortHighest: 'Avval yuqori baholilari',
    feedbackSortLowest: 'Avval past baholilari',
    feedbackFilterAria: "Baho bo'yicha filtr",
    feedbackStars: '{count} yulduz',
    feedbackRatingsCount: '{count} ta baho',
    feedbackRatingsCount_plural: '{count} ta baho',
    feedbackLoadFailed: "Fikrlarni yuklab bo'lmadi",
    feedbackNoMatchTitle: 'Fikrlar topilmadi',
    feedbackNoMatchHint: "Boshqa so'z yoki bahoni sinab ko'ring.",
    feedbackClearFilters: 'Filtrlarni tozalash',
  },
};

export default messaging;
